import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { CircleHelp, X } from 'lucide-react';
import { inboundSchemaHelpSections } from './inboundSchemaHelpData';
import './InboundSchemaGuide.css';

export const InboundSchemaGuide: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const panel = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const previousFocus = document.activeElement as HTMLElement | null;
    panel.current?.querySelector<HTMLButtonElement>('button')?.focus();
    const keys = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        event.preventDefault(); event.stopImmediatePropagation(); onClose();
      } else if (event.key === 'Tab') {
        event.preventDefault();
        event.stopImmediatePropagation();
        const targets = Array.from(panel.current?.querySelectorAll<HTMLElement>('button, a[href]') ?? []);
        const current = targets.findIndex(target => target === document.activeElement);
        const next = current < 0 ? (event.shiftKey ? targets.length - 1 : 0)
          : (current + (event.shiftKey ? -1 : 1) + targets.length) % targets.length;
        targets[next]?.focus();
      }
    };
    document.addEventListener('keydown', keys, true);
    return () => { document.removeEventListener('keydown', keys, true); previousFocus?.focus(); };
  }, [onClose]);
  return createPortal(<div className="inbound-schema-guide-overlay" onClick={event => {
    if (event.target === event.currentTarget) onClose();
  }}>
    <div className="inbound-schema-guide" role="dialog" aria-modal="true" aria-labelledby="inbound-schema-guide-title" ref={panel}>
      <header><h2 id="inbound-schema-guide-title"><CircleHelp size={20} />Inbound schema guide</h2>
        <button type="button" aria-label="Close schema guide" title="Close schema guide" onClick={onClose}><X size={18} /></button></header>
      <nav aria-label="Schema guide sections">{inboundSchemaHelpSections.map(section =>
        <a key={section.id} href={`#schema-guide-${section.id}`}>{section.title}</a>)}</nav>
      {inboundSchemaHelpSections.map(section => <section key={section.id} id={`schema-guide-${section.id}`}>
        <h3>{section.title}</h3>{section.blocks.map((block, index) => block.kind === 'code'
          ? <pre key={index}><code>{block.text}</code></pre> : <p key={index}>{block.text}</p>)}
      </section>)}
    </div>
  </div>, document.body);
};